export default __webpack_public_path__ + "static/media/nwaste_icon.1b507966.svg";